<template>
    <div>
        <CPU />
    </div>
</template>

<script>
import CPU from './CPU.vue'
export default {
    name: 'MobileItems',
    components: {
        CPU
    },
}
</script>